import React, { useState, useEffect ,useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSpinner } from 'react-icons/fa';

import { useShop } from '../context/ShopContext';
import Sidebar from "./Sidebar";



const EditDesiStockDate = () => {
  const location = useLocation();
  const navigate = useNavigate(); // For navigation
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [shopId, setShopId] = useState(null);
  const [tokenString, setToken] = useState(null);
  const [shopName,setshopName] = useState(null);

  const inputRefs = useRef([]);
  const [apiConditionMet, setApiConditionMet] = useState(null); 
  const [shopOptions, setShopOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);  
  const [rsbclData, setRsbclData] = useState(null); 
  const [transactionNo, setTransactionNo] = useState("");
   
  

const { userId ,companyId } = useShop(); // Destructure shopName from context
const [receiveType, setReceiveType] = useState("");
const [selectedTypeName, setSelectedTypeName] = useState("");
const [invoiceNo, setInvoiceNo] = useState("");
const [shop, setShop] = useState("");
const [partyMaster, setPartyMaster] = useState("");
const [receiveTypes, setReceiveTypes] = useState([]);
const [shops, setShops] = useState([]);
const [partyMasters, setPartyMasters] = useState([]);
const [selectedProducts, setSelectedProducts] = useState([]);
const [remark, setRemark] = useState(""); 
const [showPreview, setShowPreview] = useState(false);
const [previewData, setPreviewData] = useState({});
const [modalIsOpen, setModalIsOpen] = useState(false);
const [shopCodes, setShopCodes] = useState([]);
const [selectedShopCode, setSelectedShopCode] = useState("");



const showToast = (message, type = "error") => {
  toast.dismiss(); // Dismiss any existing toast before showing a new one

  console.log("Toast Type:", type); // Debugging log to check type value

  if (type.toLowerCase() === "error") {
    toast.error(message);
  } else if (type.toLowerCase() === "success") {
    toast.success(message);
  } else {
    console.warn("Invalid toast type:", type);
  }
};




   


  useEffect(() => {
    const savedShopId = localStorage.getItem("shopId");
    const savedTokenString = localStorage.getItem("tokenString");
    const savedshopName =localStorage.getItem("shopName");



    if (savedShopId && savedTokenString && savedshopName) {
      setShopId(savedShopId);
      setToken(savedTokenString);
      setshopName(savedshopName);
    } else {
      showToast("Please log in first!","error");
      navigate("/signin"); // Redirect to login page if not logged in
    }
  }, [navigate]);





  useEffect(() => {
    if (shopId && tokenString && shopName && shopName) {
      fetchStock();
    }
  }, [shopId, tokenString, shopName,date]); // Depend on shopId and tokenString



   // Set default from date to today's date on initial render
   useEffect(() => {
    const today = new Date();
    const isoDate = today.toISOString().split("T")[0]; // Get today's date in yyyy-MM-dd format
    setDate(isoDate); // Set the default date
  }, []);


   useEffect(() => {
      const today = new Date();
      const formattedDate = today
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(",", ""); // Remove comma if any
  
      // Convert to ISO 8601 format for <input type="date">
      const isoDate = today.toISOString().split("T")[0]; // yyyy-MM-dd
      setDate(isoDate);
    }, []);
  
  
  
  




 
  useEffect(() => {
    if (searchQuery.trim()) {
      const filtered = products.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products);
    }
  }, [searchQuery, products]);


  
  useEffect(() => {
    const today = new Date();
    const formattedDate = today
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(",", ""); // Remove comma if any

    // Convert to ISO 8601 format for <input type="date">
    const isoDate = today.toISOString().split("T")[0]; // yyyy-MM-dd
    setDate(isoDate);
  }, []);






  const fetchStock = async () => {
    setLoading(true);
    setError(null);
    try {
        const response = await axios.post(
            "https://winenew.sipstocks.in/api/Liquor/GetProductDataWithDate",

            { shopId, 
              typeId: "2" ,
              stockDate:date || new Date().toISOString().split("T")[0],},
            {
                headers: {
                    Authorization: `Bearer ${tokenString}`,
                },
            }
        );

        console.log("Editproductdata: ", response);
        const fetchedProducts = response.data.data || [];

        const updatedProducts = fetchedProducts.map((product) => ({
            id: product.id,
            name: product.pName,
            selected: false, // ✅ Add selected state
            variants: [
                {
                    volume: product.packing,
                    rate: parseFloat(product.mrp),
                    openingStock: parseFloat(product.openingStock || 0),
                    receivedStock: "",
                    transferStock: "",
                    currentStock: "",
                    isSubmitted: false,
                },
            ],
        }));

        setProducts(updatedProducts);
        setFilteredProducts(updatedProducts);
        setApiConditionMet(true); 
    } catch (err) {
        setError("Error fetching stock data");
        console.error("Error fetching stock:", err);
        setApiConditionMet(false); 
    } finally {
        setLoading(false);
    }
};


  






useEffect(() => {
    const fetchReceiveTypes = async () => {
      try {
        const response = await axios.post(
          'https://winenew.sipstocks.in/api/Liquor/GetRecTypeMst',
          { shopId, companyId },
          { headers: { accept: '*/*' } }
        );
        console.log("fetchReceiveTypes", response);
  
        // Map the response to dropdown options
        const options = response.data?.data?.map((item) => ({
          id: item.id,
          label: item.name,
          type: item.typeName,  // Used for condition checking
          type1:item.type,
        }));
        
        console.log("recievetypeoptions:", options);
        setReceiveTypes(options);
      } catch (err) {
        console.error('Error fetching dropdown options:', err);
        showToast('Failed to load dropdown options.',"error");
      }
    };
  
    fetchReceiveTypes();
  }, []);



  useEffect(() => {
    const fetchPartyMasters = async () => {
      try {
        const response = await axios.post(
          'https://winenew.sipstocks.in/api/Liquor/GetPartyMaster',
          { companyId },
          { headers: { accept: '*/*' } }
        );
        console.log("fetchPartyMasters", response);
  
        const options = response.data?.data?.map((item) => ({
          id: item.id,
          label: item.name,
        }));
        setPartyMasters(options);
      } catch (err) {
        console.error('Error fetching party master options:', err);
        showToast('Failed to load party masters.',"error");
      }
    };
  
    fetchPartyMasters();
  }, []);
  

  useEffect(() => {
    // Function to fetch shop options from the API
    const fetchShopOptions = async () => {
      try {
        const response = await axios.post(
          'https://winenew.sipstocks.in/api/Liquor/GetShopMaster', // API URL
          { userId ,companyId }, // Request body with userId
          {
            headers: {
              'accept': '*/*', // Accept header
              'Content-Type': 'application/json' // Content-Type header
            }
          }
        );
        console.log("fetchShopOptions67:", response)
  
        const options = response.data?.data?.map((item) => ({
          id: item.id,
          label: item.name,
        }));
        console.log("options",options)
        
        // Assuming the API returns an array of shop options
        setShopOptions(options);
        setIsLoading(false); // Set loading to false after data is fetched
      } catch (err) {
        showToast('Failed to fetch shop options');
        setIsLoading(false);
      }
    };
  
    fetchShopOptions(); // Call the function to fetch data
  }, []); // Empty dependency array means this runs only once when the component mounts


 


  const handleCheckboxChange = (productId) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected.includes(productId)) {
        return prevSelected.filter(id => id !== productId);
      } else {
        return [...prevSelected, productId];
      }
    });
  };




  const handleReceivedStockChange = (productIndex, variantIndex, value) => {
    if (!selectedProducts.includes(filteredProducts[productIndex].id)) return;
  
   
    if (value === "") {
      const updatedProducts = [...filteredProducts];
      updatedProducts[productIndex].variants[variantIndex].receivedStock = "";
      setFilteredProducts(updatedProducts);
      return;
    }
  
    const numericValue = Number(value);
  
    if (numericValue < 0) {
      showToast("Negative values are not allowed!", "error");
  
      const updatedProducts = [...filteredProducts];
      updatedProducts[productIndex].variants[variantIndex].receivedStock = "";
      setFilteredProducts(updatedProducts);
  
      return;
    }
  
 
    const updatedProducts = [...filteredProducts];
    updatedProducts[productIndex].variants[variantIndex].receivedStock = numericValue;
    setFilteredProducts(updatedProducts);
  };
  


  const handleReceiveTypeChange = async (e) => {
    const selectedId = e.target.value;
    setReceiveType(selectedId);

    const selectedOption = receiveTypes.find(
        (option) => option.id.toString() === selectedId
    );

    console.log("Selected Option:", selectedOption); 
    console.log("Selected Type:", selectedOption?.type); 

    setSelectedTypeName(selectedOption ? selectedOption.type : "");

    // Reset dependent fields
    setInvoiceNo("");
    setShop("");
    setPartyMaster("");
    setTransactionNo(""); 

  
    let apiType = selectedOption?.type1;

    console.log("Final API Type:", apiType);

    console.log("Final API Type:", apiType); 

    try {
        const response = await axios.post(
            "https://winenew.sipstocks.in/api/Liquor/GetTransactionNo",
            { type: apiType,companyId:companyId , typeId: "2"}, 
            {
                headers: {
                    accept: "*/*",
                    Authorization: `Bearer ${tokenString}`,
                },
            }
        );

        console.log("API Response:", response.data);

        if (response.data?.code === 200 && response.data?.data) {
            setTransactionNo(response.data.data); 
            showToast(`Transaction No. received!`,"success");
        } else {
          showToast("Invalid response from API!","error");
        }
    } catch (err) {
        console.error("API Error:", err);
        showToast("Failed to fetch transaction number!","error");
    }
};




  
  

const handleSubmit = async (event) => {
    event.preventDefault(); 
  
    try {
        // Step 1: General Validations
        if (!receiveType) {
          showToast("Please select a Receive Type.","error");
            return;
        }
  
        // Conditional Validations based on selectedTypeName
        if (selectedTypeName === "RSBCL" && (!invoiceNo || !remark)) {
          showToast("Invoice No. and Remark are required for RSBCL.","error");
            return;
        }
  
        if (selectedTypeName === "SHOP" && !shop) {
          showToast("Please select a Shop.","error");
            return;
        }
  
        if (selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && !partyMaster) {
          showToast("Please select a Party Master.","error");
            return;
        }
  
        // Step 2: Ensure at least one product is selected
        if (selectedProducts.length === 0) {
            showToast("Please select at least one product!", "error");
            return;
        }
  
        // Step 3: Ensure each selected product has received stock
        for (const product of filteredProducts) {
            if (selectedProducts.includes(product.id)) {
                let hasValidStock = product.variants.some(
                    (variant) => Number(variant.receivedStock || 0) > 0
                );
  
                if (!hasValidStock) {
                  showToast(`Please enter received stock for ${product.name}!`,"error");
                    return;
                }
            }
        }
  
        // Step 4: Prepare selected product data
        const selectedData = filteredProducts
            .filter((product) => selectedProducts.includes(product.id))
            .map((product) => ({
                ProductId: product.id,
                ReceivedHeadQty: product.variants.reduce(
                    (total, variant) => total + Number(variant.receivedStock || 0),
                    0
                ),
            }));
  
        // Prepare final values
        const finalInvoiceNo = invoiceNo?.trim() || "0";
        const finalPartyMaster = partyMaster || "0";
        const finalShop = shop || "0";
  
        const payload = {
            ReceivedHeadId: receiveType,
            ReceivedPartyId: finalPartyMaster,
            ReceivedShopId: finalShop,
            ShopId: shopId,
            StockDate: date || new Date().toISOString().split("T")[0],
            InvoiceNo: finalInvoiceNo,
            Remark: remark,
            TransactionNo: "0",
            TransactionNumber: transactionNo,
            receivedQtyDetails: selectedData,
            ShopCode: selectedShopCode || "0", // Use selected shop code or default to "0"
        };
  
        console.log("Data being sent to API:", JSON.stringify(payload, null, 2));
  
        setLoading(true);
  
        // Step 5: Submit data to API
        let apiUrl = "";
        // 👉 If SHOP (Shop to Shop Transfer)
        if (selectedTypeName === "SHOP") {
          apiUrl = "https://winenew.sipstocks.in/api/Liquor/SaveProductBulkReceivedDetailsStage";
        } else {
          // 👉 Normal Receive (RSBCL / Party etc.)
          apiUrl = "https://winenew.sipstocks.in/api/Liquor/SaveBulkProductReceivedDetails";
        }
        console.log("Calling API:", apiUrl);

        const response = await axios.post(
            apiUrl,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    accept: "*/*",
                },
            }
        );
  
        console.log("API Response:", response.data);
        if (response.status === 200) {
          if (response.data && response.data.code !== 200) {
              showToast(response.data.data || "Negative stock not allowed!", "error");
          } else {
              showToast("Stock report submitted successfully!", "success");
              // Refresh data on the same page without full reload
              setSelectedProducts([]);
              setInvoiceNo("");
              setRemark("");
              setShop("");
              setPartyMaster("");
              setReceiveType("");
              setTransactionNo("");
              setSelectedTypeName("");
              setSelectedShopCode("");

              // Reset receivedStock for products in UI
              const resetProducts = products.map(p => ({
              ...p,
              variants: p.variants.map(v => ({ ...v, receivedStock: "" }))
              }));
              setProducts(resetProducts);
              setFilteredProducts(resetProducts);

              // Re-fetch latest stock to reflect server state
              fetchStock();
          }
      } else {
          showToast(`Error submitting stock report: ${response.statusText}`, "error");
      }
  } catch (error) {
        console.error("Error submitting data:", error);
        showToast(error.response?.data?.message || "Failed to submit data!", "error");
    } finally {
        setLoading(false);
    }
  };



  const handlePreview = () => {
    if (filteredProducts.length === 0) {
        showToast("No product data available for preview!", "error");
        return;
    }

    // ✅ Keep product structure but filter variants where receivedStock > 0
    const editedProducts = filteredProducts
        .map((product) => ({
            ...product,
            variants: product.variants.filter(variant => variant.receivedStock > 0) // Keep only valid variants
        }))
        .filter(product => product.variants.length > 0); // Remove products with no valid variants

    if (editedProducts.length === 0) {
        showToast("No Products Edited!", "error");
    } else {
        setPreviewData({ selectedProducts: editedProducts }); // ✅ Set filtered data in state
        setShowPreview(true);
    }
};




  useEffect(() => {
  if (selectedTypeName === "RSBCL") {
    const fetchShopCodes = async () => {
      try {
        const response = await axios.post(
          "https://winenew.sipstocks.in/api/Liquor/GetShopCodeData",
          { companyId: companyId },
          { headers: { "Content-Type": "application/json" } }
        );

        console.log("Shop Codes Response:", response);
        if (response.data && response.data.data) {
          setShopCodes(response.data.data); // Assuming data array
        }
      } catch (error) {
        console.error("Error fetching shop codes:", error);
      }
    };

    fetchShopCodes();
  }
}, [selectedTypeName]);

  
  
  
  
  
return (
      <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
      {/* Content wrapper */}
      <div className="d-flex flex-column flex-column-fluid">
          {/* Toolbar */}
          <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
              {/* Toolbar container */}
              <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                  {/* Page title */}
                  <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                      {/* Title */}
                      <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                      Add Receive Desi Stock
                      </h1>
                      <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                          <li className="breadcrumb-item text-muted">
                              <a href="index.html" className="text-muted text-hover-primary">Home</a>
                          </li>
                          <li className="breadcrumb-item">
                              <span className="bullet bg-gray-500 w-5px h-2px"></span>
                          </li>
                          <li className="breadcrumb-item text-muted">Dashboards</li>
                      </ul>
                  </div>
              </div>
          </div>
    
          <div id="kt_app_content" className="app-content flex-column-fluid">
              <div id="kt_app_content_container" className="app-container container-fluid">
                  <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                      <div className="col-xl-12">
                          <div className="card card-flush h-md-100">
                              <ToastContainer />
                             
                              <div className="card-body pt-6">
                                  <div className="table-responsive">
                                      <div className="panel-body">
                                          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                              <form className="form-inline">
                                                  <div className="form-group">
                                                      <p className="form-control-static">Search Products:</p>
                                                  </div>
                                                  <div className="form-group d-flex justify-content-between gap-5">
                                                      <label htmlFor="inputsearch" className="sr-only active">Search Products</label>
                                                      <input className="form-control" id="inputsearch" placeholder="Search Products"     value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} type="text"  autoComplete="off" />
   <input
    className="form-control  "
    id="inputsearch"
    placeholder="Search Products"
    type="date"
    value={date} // Always in correct format
    max={new Date().toISOString().split("T")[0]} // Restrict future dates
    onChange={(e) => setDate(e.target.value)} // Update state
    autoComplete="off"
  />
                                                     
                                                  </div>
                                                  <div className="form-group d-flex justify-content-between gap-5 ">
                                                  <p className="form-control-static">Date:</p>
  
  </div>
                                              </form>



                                              <div className="form-group">
  <label htmlFor="receiveType">Receive Type</label>
  <select
    className="form-control"
    id="receiveType"
    value={receiveType}
    onChange={handleReceiveTypeChange}
  >
    <option value="">Select Receive Type</option>
    {receiveTypes.map((option) => (
      <option key={option.id} value={option.id}>
        {option.label}
      </option>
    ))}
  </select>
</div>

                
                
{selectedTypeName === "RSBCL" && (
  <>
    <div className="form-group">
      <label htmlFor="invoiceNo">Invoice No.</label>
      <input
        type="text"
        className="form-control"
        id="invoiceNo"
        placeholder="Enter Invoice No."
        value={invoiceNo}
        onChange={(e) => setInvoiceNo(e.target.value)}
      />
    </div>

    <div className="form-group">
      <label htmlFor="remark">Remark</label>
      <input
        type="text"
        className="form-control"
        id="remark"
        placeholder="Enter Remark"
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      />
    </div>

    {/* ✅ Dynamic Dropdown */}
 {selectedTypeName === "RSGSM" && (
  <div className="form-group">
    <label htmlFor="shopCode">Shop Code</label>
    <select
      className="form-control"
      id="shopCode"
      value={selectedShopCode}
      onChange={(e) => setSelectedShopCode(e.target.value)}
    >
      <option value="">-- Select Shop Code --</option>
      {shopCodes.map((shop) => (
        <option key={shop.id} value={shop.licenseNameCode}>
          {shop.licenseNameCode}
        </option>
      ))}
    </select>
  </div>
)}
  </>
)}


{/* Shop Dropdown (Only for SHOP) */}
{selectedTypeName === "SHOP" && (
  <div className="form-group">
    <label htmlFor="shopDropdown">Shop</label>
    <select
      className="form-control"
      id="shopDropdown"
      value={shop}
      onChange={(e) => setShop(e.target.value)}
    >
      <option value="">Select Shop</option>
      {shopOptions.map((option) => (
        <option key={option.id} value={option.id}>{option.label}</option>
      ))}
    </select>
  </div>
)}


{selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && (
  <div className="form-group">
    <label htmlFor="partyMaster">Party Master</label>
    <select
      className="form-control"
      id="partyMaster"
      value={partyMaster}
      onChange={(e) => setPartyMaster(e.target.value)}
    >
      <option value="">Select Party Master</option>
      {partyMasters.map((party) => (
        <option key={party.id} value={party.id}>
          {party.label}
        </option>
      ))}
    </select>
  </div>
)}
     


  <div className="panel-heading">
  

    {transactionNo && (
      <span
        style={{
          position: "absolute",
          right: "45px",
          top: "60px", 
          fontWeight: "bold",
          color: "green",
          fontSize: "20px",
        }}
      >
        Transaction No: {transactionNo}
      </span>
    )}
  </div>




















                                          </div>
                                          <div className="clearfix"></div>
                                          <br />
                                          {apiConditionMet === null ? (
      <div className="loader-container">
               <FaSpinner className="spinner-icon" />
             </div>
    ) : apiConditionMet ? (
                                          <div className="table-responsive h-400px">
                                              <table className="table table-bordered table-striped">
                                                  <thead>
                                                  <tr>
                      <th>Select</th>
                      <th>Product Name</th>
                      <th>Volume</th>
                      <th>Rate</th>
                      <th>Opening Stock</th>
                      <th>Received Stock</th>
                      {/* <th>Total Stock</th> */}
                    
                    </tr>
                                                  </thead>
                                                  <tbody>
                    {filteredProducts.length > 0 ? (
                      filteredProducts.map((product, index) =>
                        product.variants.map((variant, vIndex) => {
                          const totalStock = variant.openingStock + (parseFloat(variant.receivedStock) || 0);
                          return (
                            <tr key={`${index}-${vIndex}`}>
                              {/* Checkbox */}
                              <td>
  <label className="checkbox-container">
    <input
      type="checkbox"
      checked={selectedProducts.includes(product.id)}
      onChange={() => handleCheckboxChange(product.id)}
    />
   
  </label>
</td>

                              <td>{product.name}</td>
                              <td>{variant.volume}</td>
                              <td className="numeric-input">{variant.rate}</td>
                              <td className="numeric-input">{variant.openingStock}</td>

                              {/* Received Stock Input */}
                              <td className="numeric-input">
  <input
    type="text"
    value={variant.receivedStock}
    onChange={(e) => handleReceivedStockChange(index, vIndex, e.target.value)}
    className="form-control"
    min="0"
    disabled={!selectedProducts.includes(product.id)}
  />
</td>


                              {/* <td className="numeric-input">{totalStock}</td> */}
                              
                            </tr>
                          );
                        })
                      )
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">No Products Found</td>
                      </tr>
                    )}
                  </tbody>
                                              </table>
    
    
    
    
    
    
                                       
    
     

    
                                          </div>
                                            ) : (
                                              <p>Already Submitted Data</p> 
                                            )}



<div class="text-right align-items-right d-flex justify-content-end">
      <button type="submit" data-bs-toggle="modal" data-bs-target="#model3" className="btn btn-info mt-3 m-2"  onClick={handlePreview}>Preview</button>
       <button type="submit" className="btn btn-info mt-3 m-2"    onClick={handleSubmit}disabled={loading}   >{loading ? "Submitting..." : "Submit Report"}</button>
       </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    
      {/* Footer */}
      <div id="kt_app_footer" className="app-footer">
          <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
              <div className="text-gray-900 order-2 order-md-1">
                  <span className="text-muted fw-semibold me-1">2025&copy;</span>
                  <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
              </div>
          </div>
      </div>
 
    
    
    
    
    
    
    
    {/* For transfer modal */}
    
    
  
    
    
    
    
    
        {/* Preview modal */}
    
        <div
    className="modal fade"
    id="model3"
    tabIndex={-1}
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    >
    <div className="modal-dialog modal-lg">
    <div className="modal-content">
    <div className="modal-header">
    <h1 className="modal-title fs-5" id="exampleModalLabel">
    Preview Details
    </h1>
    <button
    type="button"
    className="btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    />
    </div>
    
    <div className="modal-body">
    <div className="previewdata">
            <table className="table table-bordered table-striped" >
            <thead>
            <tr>
              <th>Product Name</th>
              <th>Volume</th>
              <th>Rate</th>
              <th>Received Stock</th> 
            </tr>
          </thead>
          <tbody>
            {previewData?.selectedProducts?.map((product, index) =>
              product.variants.map((variant, vIndex) => (
                <tr key={`${index}-${vIndex}`}>
                  <td>{product.name}</td>
                  <td>{variant.volume}</td>
                  <td>{variant.rate}</td>
                  <td className="numeric-input">
                    <input
                      type="text"
                      value={variant.receivedStock || ""}
                      onChange={(e) =>
                        handleReceivedStockChange(index, vIndex, e.target.value)
                      }
                      className="form-control"
                      min="0"
                      disabled={!selectedProducts.includes(product.id)}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
            </table>
          </div>
    </div>
    
    <div className="modal-footer">
    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
    Close
    </button>
    </div>
    </div>
    </div>
    </div>
    
    </div>
);
};

export default EditDesiStockDate;